import {
	Chain,
	ChainConfig,
	ChainId,
	chains as chainsFromSDK,
} from 'symbiosis-js-sdk'

import { Config } from '~/types/config'
import { EarnType } from '~/lib/constants'
import { CrosschainConfig, OmniPoolStablesConfig } from '~/types/crosschain'
import iconArbitrum from '~/assets/chains/arbitrum-small.png'

declare const APP_CONFIG: Config
export const CONFIG = APP_CONFIG

declare const CROSSCHAIN_APP_CONFIG: CrosschainConfig
export const CROSSCHAIN_CONFIG = CROSSCHAIN_APP_CONFIG

declare const OMNIPOOL_APP_CONFIG: OmniPoolStablesConfig
export const OMNIPOOL_CONFIG = OMNIPOOL_APP_CONFIG

const arbitrumChain = new Chain({
	id: 42161,
	name: 'Arbitrum',
	disabled: false,
	explorer: 'https://arbiscan.io',
	icons: {
		small: iconArbitrum,
		large: iconArbitrum,
	},
})

export const getChainByIdFromSDK = (
	chainId: ChainId,
	withArbitrum: boolean = false
) => {
	if (!chainId) return
	return (
		withArbitrum ? chainsFromSDK.concat([arbitrumChain]) : chainsFromSDK
	).find((chain) => chain.id == chainId)
}

export const getChainById = (id: ChainId) => {
	if (!id) return
	return CONFIG.chains.find((chain) => {
		return chain.id === id
	})
}

export const getEarnByType = (earnType: EarnType) => CONFIG.earns[earnType]

export const getChainConfig = (chainId: ChainId): ChainConfig => {
	const config = CROSSCHAIN_CONFIG.chains.all.find(
		(chain) => chain.id === chainId
	)

	// throw new Error(`config for chain ${chainId} not found`)

	return config
}
